import styled from 'styled-components';

import { size } from '../layout/helpers';

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: ${size(-2)} ${size(-1)};
`;

export const Item = styled.li`
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
  padding: ${size(2)} ${size(1)};

  @media (min-width: 600px) {
    width: 50%;
    max-width: 50%;
  }

  @media (min-width: 900px) {
    width: 33.333%;
    max-width: 33.333%;
  }
`;

export const ItemContent = styled.li`
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
  padding: ${size(4)} ${size(1)};

  & + & {
    border-top: 1px solid ${(props) => props.theme.color.border};
  }
`;
